import { useState, useRef } from 'react'
import PropTypes from 'prop-types'


const TextareaField = ({value, name, label, text, valid, disable,  setFieldValid, setValue, trigger}) => {
    const textareaRef = useRef(null)
    const [focused, setFocused] = useState(false)

    const handleBlur = (ev) => {
        setFocused(false);
    }

    const handleFocus = (ev) => {
        setFocused(true);
    }

    const labelClick = (ev) => {
        textareaRef.current.focus();
        setFocused(true);
    }

    return (
        <div 
            className="form__group"
            data-disable={disable}
        >
            {label && <div className={(value || focused) ? "form__label form__label_fixed" : "form__label"} onClick={labelClick}>{label}</div>}
            <textarea 
                value={value} 
                ref={textareaRef}
                name={name}
                className="form__textarea"
                onBlur={handleBlur}
                onFocus={handleFocus}
                onChange={setValue}
             />
        </div>
    )

}

TextareaField.propTypes = {
  value: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired,
  valid_reg: PropTypes.bool.isRequired,
  trigger: PropTypes.bool.isRequired,
}


export default TextareaField